// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__DweQR","footerUpper":"Footer_footerUpper__jbP0I","footerLower":"Footer_footerLower__jlZX2"};